/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Clone } from '../../assets/themes/OPL/img/icons/Clone.svg';

function CloneButton({ ...props }) {
    const { classes, callback, tooltipTitle, tooltipPlacement, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            tooltipTitle={tooltipTitle}
            tooltipPlacement={tooltipPlacement}
            className={classes}
            classes={classes}
            icon={Clone}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

CloneButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPlacement: PropTypes.string,
};

export default CloneButton;
